// client/src/components/agent/actions/InteractiveMessageView.jsx
// Vista del panel derecho para armar y enviar un mensaje interactivo (botones,
// enlace o lista) a la conversación seleccionada en el panel central.
import { useState } from 'react';
import theme from '../../../theme';
import InteractiveBuilder from './InteractiveBuilder';
import { emptyInteractive, validateInteractive } from './interactiveLimits';

export default function InteractiveMessageView({ token, conv, onBack }) {
  const c = theme.colors;
  const [cfg, setCfg] = useState(emptyInteractive());
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState('');

  const error = validateInteractive(cfg);
  const canSend = !!conv && !error && !sending;

  const send = async () => {
    if (!canSend) return;
    setSending(true);
    setMsg('');
    try {
      const r = await fetch('/api/agent/interactive/send', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ conversation_id: conv.id, config: cfg }),
      });
      if (r.ok) {
        // Conservamos lo que armó el agente por si quiere reenviarlo a otro usuario
        // sin volver a llenarlo desde cero.
        setMsg('✓ Enviado');
      } else {
        const j = await r.json().catch(() => ({}));
        setMsg(j.message || 'Error al enviar');
      }
    } catch {
      setMsg('Error de conexión');
    }
    setSending(false);
  };

  return (
    <div style={{ padding: 12, color: c.text, overflowY: 'auto' }}>
      <button onClick={onBack} style={{ background: 'none', border: 'none', color: c.primary, cursor: 'pointer', marginBottom: 8 }}>← Atrás</button>
      <h4 style={{ margin: '0 0 10px' }}>Textos interactivos</h4>

      {!conv && (
        <div style={{ color: c.textMuted, fontSize: 12, lineHeight: 1.5, marginBottom: 10 }}>
          Selecciona una conversación en el panel central para poder enviar.
        </div>
      )}

      <InteractiveBuilder value={cfg} onChange={setCfg} token={token} />

      {msg && (
        <p style={{ color: msg.startsWith('✓') ? c.success : c.error, fontSize: 12, margin: '10px 0 0' }}>{msg}</p>
      )}
      {conv && error && (
        <p style={{ color: c.textMuted, fontSize: 11, margin: '8px 0 0' }}>{error}</p>
      )}

      <button
        onClick={send}
        disabled={!canSend}
        title={!conv ? 'Selecciona una conversación' : (error || undefined)}
        style={{
          width: '100%', marginTop: 12, padding: '10px', borderRadius: 8, border: 'none',
          background: canSend ? c.primary : c.border, color: canSend ? '#001018' : c.textMuted,
          fontWeight: 700, cursor: canSend ? 'pointer' : 'not-allowed',
        }}>
        {sending ? 'Enviando…' : 'Enviar a la conversación'}
      </button>
    </div>
  );
}
